export let Experiences = {
 hide_payg : {
  experience_name : '#30: Remove PAYG on Plan Page',
  variation_name : 'No PAYG'
 },
 number_confirm_ab : {
  experience_name : 'Number confirmation removal',
  variation_name : 'No number confirm'
 }
}